export const REQUEST_LOGIN = "REQUEST_LOGIN";
export const AUTHENTICATED = "AUTHENTICATED";
export const LOGOUT = "LOGOUT";
export const CLEAR_AUTH = "CLEAR_AUTH";

export const START_WATCHER_TASK = "START_WATCHER_TASK";
export const STOP_WATCHER_TASK = "STOP_WATCHER_TASK";

export const START_WATCHER_REFRESH_TOKEN = "START_WATCHER_REFRESH_TOKEN";
export const STOP_WATCHER_REFRESH_TOKEN = "STOP_WATCHER_REFRESH_TOKEN";

export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const requestLogin = () => {
    return {
        type: REQUEST_LOGIN,
    };
};

export const authenticated = (keycloak, userProfile, userInfo, technicianInfo) => {
    return {
        type: AUTHENTICATED,
        keycloak,
        userProfile,
        userInfo,
        technicianInfo,
    };
};

export const refreshToken = (keycloak) => {
    return {
        type: REFRESH_TOKEN,
        keycloak,
    };
};

export const genToken = (keycloak) => {
    return {
        type: AUTHENTICATED,
        keycloak,
    };
};

export const logout = () => {
    return {
        type: LOGOUT,
    };
};

export const clearAuth = () => {
    return {
        type: CLEAR_AUTH,
    };
};

export const startPolling = () => {
    return {
        type: START_WATCHER_TASK,
    };
};

export const stopPolling = () => {
    return {
        type: STOP_WATCHER_TASK,
    };
};

export const startRefreshPolling = () => {
    return {
        type: START_WATCHER_REFRESH_TOKEN,
    };
};

export const stopRefreshPolling = () => {
    return {
        type: STOP_WATCHER_REFRESH_TOKEN,
    };
};
